import React, { useState, useEffect } from 'react';
import './AllIndents.css'; 
import { jsPDF } from 'jspdf'; 
import 'jspdf-autotable'; 

import { WardDetails } from '../../Datas/WardDetails';

const AllIndents = () => {
  const wardDetails = WardDetails[0]; 
  const [medicines, setMedicines] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMedicine, setSelectedMedicine] = useState(null);

  useEffect(() => {
    const outOfStockMedicines = wardDetails.inventory.filter(medicine => medicine.stockLevel <= 5);
  
    const updatedMedicines = outOfStockMedicines.map(medicine => {
      const issueQuantity = Math.floor(Math.random() * 100 + 1); 
      const totalCost = issueQuantity * medicine.ratePerUnit;  
      const expiryDate = new Date(medicine.expiryDate);
      const currentDate = new Date();
      const timeDiff = expiryDate - currentDate;
      const daysRemaining = Math.floor(timeDiff / (1000 * 3600 * 24));

      // Check if expired
      const expiryStatus = timeDiff < 0 ? "EXPIRED" : `${medicine.expiryDate}`;

      return {
        ...medicine,
        issueQuantity,
        totalCost,  
        daysRemaining, 
        expiryStatus,  // Add expiryStatus to store EXPIRED or the actual date
      };
    });
  
    setMedicines(updatedMedicines);
  }, [wardDetails.inventory]); 

  const handleDelete = (medicineName) => {
    const updatedMedicines = medicines.filter(medicine => medicine.name !== medicineName);
    setMedicines(updatedMedicines); 
    alert(`Deleted ${medicineName}`);
  };

  const handleEdit = (medicine) => {
    setSelectedMedicine(medicine);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedMedicine(null);
  };

  const handleUpdateMedicine = (e) => {
    e.preventDefault();

    const updatedMedicines = medicines.map(medicine => {
      if (medicine.name === selectedMedicine.name) {
        const totalCost = selectedMedicine.issueQuantity * selectedMedicine.ratePerUnit;
        const expiryDate = new Date(selectedMedicine.expiryDate);
        const currentDate = new Date();
        const timeDiff = expiryDate - currentDate;
        const daysRemaining = Math.floor(timeDiff / (1000 * 3600 * 24));

        // Update expiry status
        const expiryStatus = timeDiff < 0 ? "EXPIRED" : `${selectedMedicine.expiryDate}`;
        
        return { 
          ...selectedMedicine, 
          totalCost, 
          daysRemaining, 
          expiryStatus  // Update expiry status here too
        };
      }
      return medicine;
    });
    
    setMedicines(updatedMedicines);
    handleModalClose();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedMedicine({
      ...selectedMedicine,
      [name]: value,
    });
  };

  const handleExportToPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text(`Ward: ${wardDetails.wardName}`, 14, 20);
    doc.text(`Location: ${wardDetails.location}`, 14, 30);
    doc.text(`Head Doctor: ${wardDetails.headDoctor}`, 14, 40);
    doc.text(`Request Docker No.: XYZ-123`, 14, 50); 
    doc.text(`Issue Date: ${new Date().toLocaleDateString()}`, 14, 60); 
    doc.text(`Request Date: ${new Date().toLocaleDateString()}`, 14, 70); 

    doc.setFontSize(12);
    doc.text("Out of Stock Medicines List", 14, 80);
    doc.autoTable({
      startY: 90, 
      head: [['Medicine Name', 'Stock Level', 'Issue Quantity', 'Batch Number', 'Expiry Date', 'Rate per Unit', 'Total Cost']],
      body: medicines.map(medicine => [
        medicine.name,
        medicine.stockLevel,
        medicine.issueQuantity,
        medicine.batchNumber,
        medicine.expiryStatus, // Use the expiryStatus instead of the actual date
        `₹${medicine.ratePerUnit.toFixed(2)}`,
        `₹${medicine.totalCost.toFixed(2)}`
      ]),
      theme: 'grid',
      margin: { horizontal: 10 },
      styles: { fontSize: 10, cellPadding: 2 }
    });

    doc.save('medicine_indent.pdf');
  };

  return (
    <div className="container">
      <table className="medicine-table">
        <thead>
          <tr>
            <th>Medicine Name</th>
            <th>Stock Level</th>
            <th>Issue Quantity</th>
            <th>Batch Number</th>
            <th>Expiry Date</th>
            <th>Rate per Unit</th>
            <th>Total Cost</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {medicines.map((medicine, index) => (
            <tr key={index} className={medicine.stockLevel < 1 ? 'low-stock' : ''}>
              <td>{medicine.name}</td>
              <td>{medicine.stockLevel}</td>
              <td>{medicine.issueQuantity}</td>
              <td>{medicine.batchNumber}</td>
              <td>{medicine.expiryStatus}</td> {/* Display expiryStatus */}
              <td>{`₹${medicine.ratePerUnit.toFixed(2)}`}</td>
              <td>{`₹${medicine.totalCost.toFixed(2)}`}</td>
              <td>
                <button className="edit-btn-indent" onClick={() => handleEdit(medicine)}>Edit</button>
                <button className="delete-btn-indent" onClick={() => handleDelete(medicine.name)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="actions">
        <button className="submit-btn-indent">Submit to Pharmacy</button>
        <button className="export-btn-indent" onClick={handleExportToPDF}>Export Form</button>
      </div>

      {isModalOpen && selectedMedicine && (
        <div className="modal-indent-edit">
          <div className="modal-content-indent-edit">
            <h3>Edit Medicine Details</h3>
            <form onSubmit={handleUpdateMedicine}>
              <label>
                Medicine Name:
                <input
                  type="text"
                  name="name"
                  value={selectedMedicine.name}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label>
                Stock Level:
                <input
                  type="number"
                  name="stockLevel"
                  value={selectedMedicine.stockLevel}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label>
                Issue Quantity:
                <input
                  type="number"
                  name="issueQuantity"
                  value={selectedMedicine.issueQuantity}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label>
                Batch Number:
                <input
                  type="text"
                  name="batchNumber"
                  value={selectedMedicine.batchNumber}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label>
                Expiry Date:
                <input
                  type="date"
                  name="expiryDate"
                  value={selectedMedicine.expiryDate}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label>
                Rate per Unit (₹):
                <input
                  type="number"
                  name="ratePerUnit"
                  value={selectedMedicine.ratePerUnit}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <div className="modal-actions-indent">
                <button type="submit">Save Changes</button>
                <button type="button" onClick={handleModalClose}>Close</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllIndents;
